import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ReplyIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", width = 24, height = 24, ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} width={width} height={height} {...rest}>
            <path
                d="M13.4814815,21.2 C17.4125492,21.2 20.6,18.0216044 20.6,14.1 C20.6,10.1783956 17.4125492,7 13.4814815,7 L4,7 L4,8.2 L13.4814815,8.2 C16.7505705,8.2 19.4,10.8419027 19.4,14.1 C19.4,17.3580973 16.7505705,20 13.4814815,20 L13.4814815,21.2 Z"
                fill="currentColor"
            ></path>
            <polygon
                fill="currentColor"
                transform="translate(5.374817, 7.618448) rotate(-90.000000) translate(-5.374817, -7.618448) "
                points="5.37481703 6.53674982 10 10.2368962 10.7496341 9.29985362 5.37481703 5 0 9.29985362 0.749634057 10.2368962"
            ></polygon>
        </SvgIcon>
    );
};
